export function clearGoogleAnalyticsCookies(
  document: { cookie: string } | undefined,
  href: string | undefined,
  measurementId: string,
): void {
  if (!document || !href) return
  try {
    const url = new URL(href)
    const names = new Set(['_ga', `_ga_${measurementId.replace(/^G-/, '')}`])
    const present = document.cookie.split(';').map(part => part.split('=', 1)[0].trim())
      .filter(name => names.has(name))
    const domains = new Set([''])
    const parts = url.hostname.split('.')
    for (let i = 0; i < parts.length - 1; i++) {
      const domain = parts.slice(i).join('.')
      domains.add(domain)
      domains.add(`.${domain}`)
    }
    const paths = new Set(['/'])
    const segments = url.pathname.split('/').filter(Boolean)
    for (let i = 1; i <= segments.length; i++) {
      paths.add('/' + segments.slice(0, i).join('/'))
    }
    for (const name of present) for (const domain of Array.from(domains)) for (const path of Array.from(paths)) {
      document.cookie = `${name}=; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=${path}; SameSite=Lax${domain ? `; Domain=${domain}` : ''}${url.protocol === 'https:' ? '; Secure' : ''}`
    }
  } catch {
    // Cookie access can be blocked. The provider disable flag still applies.
  }
}
